import type {
  VacancyResource,
  InterviewResource
} from 'api/endpoints/openapi-generated.schemas'
import type { VariablesType } from 'constants/vacancy'

export function getVariables(
  vacancy: VacancyResource,
  interview: InterviewResource | null
): VariablesType {
  return {
    candidateName: interview?.candidate_name,
    companyTitle: vacancy.overridden_company_title || vacancy.company.name,
    vacancyTitle: vacancy.title,
    vacancyHREmail: '',
    interviewUrl: `/interview/${vacancy.id}`
  }
}
